import { Gift, Home, User } from 'react-feather';

export default [
  {
    id: 'sign-in',
    title: 'Sign In',
    icon: <User size={20} />,
    navLink: '/login',
    action: 'read',
    resource: 'sign-in',
  },
  {
    id: 'locations',
    title: 'Locations',
    icon: <Home size={20} />,
    navLink: '/',
    action: 'read',
    resource: 'locations',
  },
  {
    id: 'gift-cards',
    title: 'Gift Cards',
    icon: <Gift size={20} />,
    navLink: '/gift-card',
    action: 'read',
    resource: 'locations',
  },
];
